<template>
  <img
    src="/img/logos/highlevel_icon.png"
    alt="HighLevel"
    class="size-4 shrink-0 object-contain aspect-square"
    aria-hidden="true"
    v-bind="$attrs"
  />
</template>
